<template>
    <div class="flex">
      <div class="mr-2">
        <label class="block text-sm font-medium leading-5 text-gray-700" for="start-date">Fecha de inicio:</label>
        <input 
          type="date" 
          id="start-date"
          class="disabled:bg-gray-200 disabled:cursor-not-allowed form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="startDate" 
          :max="endDate"
          @change="onDateChange"
        />
      </div>
      <div>
        <label class="block text-sm font-medium leading-5 text-gray-700" for="end-date">Fecha de fin:</label>
        <input 
          type="date" 
          id="end-date"
          class="disabled:bg-gray-200 disabled:cursor-not-allowed form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="endDate" 
          :min="startDate"
          @change="onDateChange"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      onDateRangeChange: {
        type: Function,
        required: false,
      },
    },
    data() {
      return {
        startDate: '', // Fecha de inicio seleccionada
        endDate: '',   // Fecha de fin seleccionada
      };
    },
    methods: {
      onDateChange() {
        this.$emit('date-range-change', { startDate: this.startDate, endDate: this.endDate });
        if (this.onDateRangeChange) {
        this.onDateRangeChange({ startDate: this.startDate, endDate: this.endDate });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos opcionales */
  input {
    display: block;
    margin-bottom: 10px;
  }
  </style>
  